const searchInit = (searchPopup: HTMLElement) => {
  const body: HTMLBodyElement = document.querySelector('body');
  const searchForm = searchPopup.querySelector('.aws-search-form') as HTMLFormElement;
  const searchInput = searchPopup.querySelector('.aws-search-field') as HTMLInputElement;
  const suggestions = searchPopup.querySelector('.search-results__result--suggestions') as HTMLElement;
  const suggestionsInner = suggestions.querySelector('.search-results__inner-result') as HTMLElement;
  const blogs = searchPopup.querySelector('.search-results__result--blog') as HTMLElement;
  const blogsInner = blogs.querySelector('.search-results__inner-result') as HTMLElement;
  const contentGroup = searchPopup.querySelector('.search-results__content-group') as HTMLElement;
  const headerSearch = document.querySelectorAll('.header__search, .search-results__title, .search-results__overlay') as NodeListOf<HTMLElement>;
  let searchTimeout: NodeJS.Timeout;

  // Functions
  const toggleSearchPopup = () => {
    searchPopup.classList.toggle('search-results--active');
    body.classList.toggle('fixed-body');

    if (searchPopup.classList.contains('search-results--active')) {
      searchInput.focus();
    } else {
      searchInput.blur();
    }
  };

  const toggleContentGroup = (show: Boolean) => {
    if (show) {
      contentGroup.classList.remove('search-results__content-group--hidden');
    } else {
      contentGroup.classList.add('search-results__content-group--hidden');
    }
  };

  const boldString = (str, substr) : string => {
    const newSubtr = substr.charAt(0).toUpperCase() + substr.slice(1);
    const strRegExp = new RegExp(newSubtr, 'g');
    return str.replace(strRegExp, `<b>${newSubtr}</b>`);
  };

  // Ajax request to the server to get the blogs (news)
  const startBlogSearch = (value) => {
    blogsInner.innerHTML = '';

    fetch(
      `/wp-json/sb_api/v1/searchResults?search=${value}`,
      {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
      },
    )
      .then((response) => response.json())
      .then((data) => {
        if (data.length) {
          data.forEach((item) => {
            const anchor = document.createElement('a');

            anchor.setAttribute('href', item.link);
            anchor.innerHTML = boldString(item.title, value);
            anchor.className = 'search-results__link';

            // Add anchor variable to the suggestions element
            blogsInner.insertAdjacentElement('beforeend', anchor);
          });
        } else {
          // No item has been found
          const span = document.createElement('span');
          span.innerText = blogs.dataset.noresults;
          span.className = 'search-results__link';

          // Add span variable to the suggestions element
          blogsInner.insertAdjacentElement('beforeend', span);
        }

        toggleContentGroup(true);
      })
      .catch((error) => {
        throw new Error(error);
      });
  };

  const getAWSSearchResults = (value: string) => {
    const AWSItems = document.querySelectorAll('.aws_result_item') as NodeListOf<HTMLLIElement>;
    suggestionsInner.innerHTML = '';

    // Foreach AWSItems as item
    if (!searchForm.classList.contains('aws-processing')) {
      if (AWSItems.length > 0) {
        AWSItems.forEach((item) => {
          if (!item.classList.contains('aws_search_more') && !item.classList.contains('aws_no_result')) {
            // Create new anchor element
            const anchor = document.createElement('a');

            const itemLink = item.querySelector('.aws_result_link_top') as HTMLAnchorElement;
            const itemTitle = item.querySelector('.aws_result_title') as HTMLElement;
            const link = itemLink?.href;
            const title = itemTitle?.innerHTML;

            anchor.setAttribute('href', link);
            anchor.innerHTML = boldString(title, value);
            anchor.className = 'search-results__link';

            // Add anchor variable to the suggestions element
            suggestionsInner.insertAdjacentElement('beforeend', anchor);
          } else if (item.classList.contains('aws_no_result')) {
            const span = document.createElement('span');
            span.innerText = suggestions.dataset.noresults;
            span.className = 'search-results__link';

            // Add span variable to the suggestions element
            suggestionsInner.insertAdjacentElement('beforeend', span);
          }
        });

        toggleContentGroup(true);
      } else {
        const span = document.createElement('span');
        span.innerText = suggestions.dataset.noresults;
        span.className = 'search-results__link';

        // Add span variable to the suggestions element
        suggestionsInner.insertAdjacentElement('beforeend', span);
        toggleContentGroup(true);
      }
    } else {
      setTimeout(() => {
        getAWSSearchResults(value);
        toggleContentGroup(false);
      }, 1000);
    }
  };

  // On searchForm submit event prevent default
  searchForm.addEventListener('submit', (event: Event) => {
    event.preventDefault();

    searchInput.blur();
  });

  // On typing get the current value of searchInput
  searchInput.addEventListener('keyup', () => {
    const { value } = searchInput;

    // Clear the searchTimeout
    clearTimeout(searchTimeout);

    // Toggle the content group
    toggleContentGroup(false);

    // Set timeout of 1000 milliseconds and send the value to getAWSSearchResults
    searchTimeout = setTimeout(() => {
      startBlogSearch(value);
      getAWSSearchResults(value);
    }, 1000);
  });

  // Loop through all headerSearch to toggle the search
  [...headerSearch].forEach((item) => {
    item.addEventListener('click', () => {
      toggleSearchPopup();
    });
  });
};

export default searchInit;
